






































import { Component, Vue } from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import _ from "lodash";
import Api from "@/store/surelockApi";
import { getInstance } from "@/auth/authPlugin";
import { SURELOCK_SCOPES, PRESERVATION_UPDATE_STATUSES } from "@/utils/constants";
import PreservationModel from '@/models/PreservationModel';

@Component({
  components: {
    FontAwesomeIcon,
  },
})
export default class EditPreservation extends Vue { 
  createUser = false;
  retrievalUser = false;

  updateId = '';
  updateDescription = '';
  updateStatus = '';
  updateSent = false;

  updateStatuses = PRESERVATION_UPDATE_STATUSES;
  async successCallback(): Promise<void> {
    return;
  }

  async mounted(): Promise<void> {
    const authService = getInstance();
    this.retrievalUser = await authService.userHasSurelockScope(
      SURELOCK_SCOPES.RETRIEVE_PRESERVATION
    );
    this.createUser = await authService.userHasSurelockScope(
      SURELOCK_SCOPES.CREATE_PRESERVATION
    );
  }

  setUpdateStatus(status: string): void {
    this.updateStatus = status;
  }

  showModal(row: PreservationModel, successCallback: () => Promise<void>): void {
    this.successCallback = successCallback;
    this.updateId = row.id || '';
    this.updateStatus = row.status || '';
    this.updateDescription = row.description || '';
    this.updateSent = row.sent || false;
    this.$bvModal.show('update-modal');
  }

  async submitPreservationUpdate(): Promise<void> {
    try {
      if (this.retrievalUser && PRESERVATION_UPDATE_STATUSES.includes(this.updateStatus)) {
        await Api.updatePreservation(this.updateId, this.updateDescription, this.updateStatus, this.updateSent);
      } else {
        await Api.updatePreservation(this.updateId, this.updateDescription);
      }

      await this.successCallback();

      this.$toasted.success('Preservation record updated successfully', { duration: 3000 });
    } catch (err) {
      const message = _.get(err, 'response.data.message') || 'Update request failed';
      this.$toasted.error(message, { duration: 3000 });
    }
  }
}
